import script from "./DatePresetSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePresetSelector.vue?vue&type=script&setup=true&lang=js"

import "./DatePresetSelector.vue?vue&type=style&index=0&id=4a37fa5e&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a37fa5e"]])

export default __exports__